/* QH Logo — three variants × three palettes
   Each is rendered fresh based on `palette` prop */

const QHLogo = ({ variant = 'geometric', palette = 'vault', size = 28, showWordmark = true, mono = false }) => {
  const palettes = {
    vault:  { brand: mono ? 'currentColor' : '#0B1F3A', accent: mono ? 'currentColor' : '#C9A24B', ink: '#0B1F3A' },
    pulse:  { brand: mono ? 'currentColor' : '#1E1B4B', accent: mono ? 'currentColor' : '#7C5CFF', ink: '#1E1B4B' },
    grove:  { brand: mono ? 'currentColor' : '#0F3D2E', accent: mono ? 'currentColor' : '#C9742A', ink: '#0F3D2E' },
  };
  const c = palettes[palette] || palettes.vault;
  const h = size;
  
  // VARIANT A — Geometric: hexagonal vault with QH inset
  if (variant === 'geometric') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <svg width={h} height={h} viewBox="0 0 40 40" fill="none">
          <path d="M20 2 L36 11 L36 29 L20 38 L4 29 L4 11 Z" fill={c.brand} />
          <path d="M20 6 L32 13 L32 27 L20 34 L8 27 L8 13 Z" fill="none" stroke={c.accent} strokeWidth="0.8" opacity="0.5"/>
          <text x="20" y="25" textAnchor="middle" fontFamily="Inter, sans-serif" fontWeight="700" fontSize="13" fill={c.accent} letterSpacing="-0.02em">QH</text>
        </svg>
        {showWordmark && (
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
            <span style={{ fontWeight: 600, fontSize: h * 0.5, letterSpacing: '-0.01em', color: c.ink }}>QH Management</span>
            <span style={{ fontSize: h * 0.28, color: c.ink, opacity: 0.55, letterSpacing: '0.12em', textTransform: 'uppercase', marginTop: 2 }}>Finance · Schemes</span>
          </span>
        )}
      </span>
    );
  }
  
  // VARIANT B — Abstract / Modern fintech: stacked diamonds forming Q+H lockup
  if (variant === 'abstract') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
        <svg width={h} height={h} viewBox="0 0 40 40" fill="none">
          <rect x="4" y="4" width="14" height="14" rx="2" fill={c.brand} transform="rotate(45 11 11)"/>
          <rect x="22" y="22" width="14" height="14" rx="2" fill={c.accent} transform="rotate(45 29 29)"/>
          <rect x="22" y="4" width="14" height="14" rx="2" fill="none" stroke={c.brand} strokeWidth="2" transform="rotate(45 29 11)"/>
          <rect x="4" y="22" width="14" height="14" rx="2" fill="none" stroke={c.accent} strokeWidth="2" transform="rotate(45 11 29)"/>
        </svg>
        {showWordmark && (
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
            <span style={{ fontWeight: 700, fontSize: h * 0.5, letterSpacing: '-0.025em', color: c.ink, fontFamily: 'Inter, sans-serif' }}>qh<span style={{color: c.accent}}>.</span></span>
            <span style={{ fontSize: h * 0.26, color: c.ink, opacity: 0.55, letterSpacing: '0.18em', textTransform: 'uppercase', marginTop: 2, fontWeight: 500 }}>capital os</span>
          </span>
        )}
      </span>
    );
  }
  
  // VARIANT C — Classic: monogram Q with stylized H bar (banking heritage)
  if (variant === 'classic') {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
        <svg width={h} height={h} viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="18" fill={c.brand}/>
          <circle cx="20" cy="20" r="14" fill="none" stroke={c.accent} strokeWidth="0.6" opacity="0.6"/>
          <circle cx="20" cy="20" r="11" fill="none" stroke={c.accent} strokeWidth="1.2"/>
          <path d="M27 27 L33 33" stroke={c.accent} strokeWidth="2.5" strokeLinecap="round"/>
          <line x1="14" y1="20" x2="26" y2="20" stroke={c.accent} strokeWidth="1.5"/>
        </svg>
        {showWordmark && (
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
            <span style={{ fontFamily: 'Inter, serif', fontWeight: 600, fontSize: h * 0.48, letterSpacing: '0.02em', color: c.ink, textTransform: 'uppercase' }}>Q · H</span>
            <span style={{ fontSize: h * 0.22, color: c.ink, opacity: 0.6, letterSpacing: '0.22em', textTransform: 'uppercase', marginTop: 3, fontWeight: 500 }}>est · trust · finance</span>
          </span>
        )}
      </span>
    );
  }
  return null;
};
window.QHLogo = QHLogo;
